import { AgreementTypesConstants } from "../constants"

export const checkAgreementAcceptanceStatus = (agreements = [], globalIdentity, contractId) => {
    const processedAgreements = getPendingAgreementsToAccept(agreements, globalIdentity, contractId, true)
    if (processedAgreements.available.length > 0 && processedAgreements.pending.length == 0) {
        return true
    }
    else {
        return false
    }
}

export const getPendingAgreementsToAccept = (agreements = [], globalIdentity, contractId, withoutApiAgreement = false) => {
    const returnValue = {
        all: agreements,
        available: [],
        pending: [],
        accepted: []
    }

    if (withoutApiAgreement) {
        returnValue.available = [...agreements.filter(e => {
            if (
                e.agreementType == AgreementTypesConstants.PARTNER_CONTRACT
                || e.agreementType == AgreementTypesConstants.USER_LICENSE_GDPR
            ) {
                return true
            }
            else {
                return false
            }
        })]
    }
    else {
        returnValue.available = [...agreements.filter(e => {
            if (
                e.agreementType == AgreementTypesConstants.API_AGREEMENT
                || e.agreementType == AgreementTypesConstants.PARTNER_CONTRACT
                || e.agreementType == AgreementTypesConstants.USER_LICENSE_GDPR
            ) {
                return true
            }
            else {
                return false
            }
        })]
    }

    returnValue.pending = [...returnValue.available.filter(e => !((e.agreementType ==AgreementTypesConstants.PARTNER_CONTRACT && e.agreementAcceptances?.some(i => i.contractID == contractId )) || (e.agreementType !=AgreementTypesConstants.PARTNER_CONTRACT && e.agreementAcceptances.some(i => i.globalIdentity == globalIdentity))))];
    returnValue.accepted = [...returnValue.available.filter(e => (e.agreementType ==AgreementTypesConstants.PARTNER_CONTRACT && e.agreementAcceptances?.some(i => i.contractID == contractId )) || (e.agreementType !=AgreementTypesConstants.PARTNER_CONTRACT && e.agreementAcceptances.some(i => i.globalIdentity == globalIdentity)))];

    return returnValue
}

export const getAPI_AgreementAcceptanceStatus = (agreements = [], globalIdentity) => {
    const typed_agreements = [...agreements].filter(e => e.agreementType == AgreementTypesConstants.API_AGREEMENT)
    const hasUserAgreed = !!typed_agreements.find(e => ((e.agreementAcceptances || []).length > 0 && (e.agreementAcceptances || []).find(i => i.globalIdentity == globalIdentity)))

    return ({
        hasUserAgreed: hasUserAgreed,
        agreements: typed_agreements
    })
}

export const getPartner_ContractAcceptanceStatus = (agreements = [], contractId) => {
    const typed_agreements = [...agreements].filter(e => e.agreementType == AgreementTypesConstants.PARTNER_CONTRACT)   
    const hasUserAgreed = typed_agreements.some(e => e.contractID == contractId && e.agreementAcceptances?.some(i => i.contractID == contractId));
    
    return ({
        hasUserAgreed: hasUserAgreed,
        agreements: typed_agreements
    })
}

export const getGDPRAcceptanceStatus = (agreements = [], globalIdentity) => {
    const typed_agreements = [...agreements].filter(e => e.agreementType == AgreementTypesConstants.USER_LICENSE_GDPR)
    const hasUserAgreed = !!typed_agreements.find(e => ((e.agreementAcceptances || []).length > 0 && (e.agreementAcceptances || []).find(i => i.globalIdentity == globalIdentity)))

    return ({
        hasUserAgreed: hasUserAgreed,
        agreements: typed_agreements
    })
}